// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────
   HELP PANEL (navbar dropdown)
───────────────────────────────────────── */

.help-panel-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1999;
}

.help-panel {
  position: fixed;
  top: 63px;
  right: 0;
  width: 420px;
  max-height: calc(100vh - 63px);
  background: #fff;
  border-left: 1px solid #E3EBF8;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.10);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  font-family: 'Poppins', sans-serif;
}

.help-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 16px 12px;
  border-bottom: 1px solid #E3EBF8;
  flex-shrink: 0;
}

.help-panel-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a2e;
}

.help-panel-subtitle {
  font-size: 12px;
  color: #898989;
  margin-top: 2px;
}

.help-panel-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #898989;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: background 0.15s, color 0.15s;
}

.help-panel-close:hover {
  background: #f3f4f6;
  color: #1a1a2e;
}

.help-panel-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 12px 16px;
}

.help-panel-body::-webkit-scrollbar {
  width: 4px;
}

.help-panel-body::-webkit-scrollbar-thumb {
  background: #E3EBF8;
  border-radius: 4px;
}

.help-section {
  margin-bottom: 16px;
}

.help-section-label {
  margin-bottom: 10px;
}

.help-section-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #C9194A;
  background: #fdf2f5;
  border-radius: 4px;
  padding: 2px 8px;
}

.help-section-badge--all {
  color: #1D4ED8;
  background: #eff6ff;
}

.help-video-card {
  display: flex;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f3f4f6;
  align-items: flex-start;
}

.help-video-card:last-child {
  border-bottom: none;
}

.help-video-thumbnail {
  flex-shrink: 0;
  width: 100px;
  height: 56px;
  border-radius: 6px;
  overflow: hidden;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.help-thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.help-thumbnail-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #fdf2f5, #ffe4ec);
}

.help-video-info {
  flex: 1 1;
  min-width: 0;
}

.help-video-title {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.help-video-desc {
  font-size: 11px;
  color: #898989;
  line-height: 1.4;
  margin-bottom: 8px;
}

.help-watch-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #C2185B 0%, #C9194A 100%);
  border: none;
  border-radius: 6px;
  padding: 4px 12px;
  cursor: pointer;
  transition: opacity 0.15s;
}

.help-watch-btn:hover:not(:disabled) {
  opacity: 0.88;
}

.help-watch-btn:disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: not-allowed;
}

.help-panel-footer {
  padding: 12px 16px;
  border-top: 1px solid #E3EBF8;
  text-align: center;
  flex-shrink: 0;
}

.help-channel-link {
  font-size: 12px;
  color: #C9194A;
  text-decoration: none;
  font-weight: 500;
}

.help-channel-link:hover {
  text-decoration: underline;
  color: #C9194A;
}

/* Mobile: full-width panel */
@media (max-width: 767.98px) {
  .help-panel {
    width: 100%;
    right: 0;
    left: 0;
  }
}


/* ─────────────────────────────────────────
   FLOATING VIDEO PLAYER
───────────────────────────────────────── */

.help-player {
  width: 360px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  border-top: 3px solid #C9194A;
  overflow: hidden;
  font-family: 'Poppins', sans-serif;
  -webkit-user-select: none;
          user-select: none;
}

.help-player--mobile {
  width: calc(100vw - 16px);
  left: 8px !important;
  right: 8px !important;
  bottom: 80px !important; /* above mobile bottom nav */
}

.help-player-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  background: #fafafa;
  border-bottom: 1px solid #f3f4f6;
  min-height: 36px;
}

.help-player-title {
  font-size: 12px;
  font-weight: 600;
  color: #1a1a2e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
  flex: 1 1;
}

.help-player-controls {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.help-ctrl-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #6c757d;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: background 0.15s, color 0.15s;
  padding: 0;
}

.help-ctrl-btn:hover {
  background: #f3f4f6;
  color: #1a1a2e;
}

.help-ctrl-close:hover {
  background: #fee2e2;
  color: #dc2626;
}

.help-player-iframe {
  width: 100%;
  height: 202px; /* 16:9 for 360px width */
  border: none;
  display: block;
}

/* Minimized pill */
.help-player-minimized {
  width: 280px;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14);
  border-left: 3px solid #C9194A;
  overflow: hidden;
  font-family: 'Poppins', sans-serif;
  -webkit-user-select: none;
          user-select: none;
}

.help-player-mini-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px 8px 14px;
  gap: 8px;
}

.help-player-mini-title {
  font-size: 12px;
  font-weight: 600;
  color: #1a1a2e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
}

/* Fullscreen modal */
.help-fullscreen-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.72);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.help-fullscreen-modal {
  width: min(80vw, 900px);
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.28);
  border-top: 3px solid #C9194A;
  font-family: 'Poppins', sans-serif;
}

.help-fullscreen-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #fafafa;
  border-bottom: 1px solid #f3f4f6;
}

.help-fullscreen-iframe {
  width: 100%;
  height: 56.25vw; /* 16:9 relative to 80vw container width */
  max-height: 60vh;
  border: none;
  display: block;
}

@media (max-width: 767.98px) {
  .help-player-minimized {
    width: calc(100vw - 16px);
    border-radius: 12px;
  }
  .help-fullscreen-modal {
    width: 100vw;
    border-radius: 0;
  }
  .help-fullscreen-iframe {
    height: 56.25vw;
    max-height: 50vh;
  }
}


/* ─────────────────────────────────────────
   GUIDED TOUR BANNER (inside HelpPanel)
───────────────────────────────────────── */

.help-tour-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #fdf2f5;
  border: 1px solid #f9c8d6;
  border-radius: 8px;
  padding: 10px 14px;
  margin: 12px 16px 4px;
  flex-shrink: 0;
}

.help-tour-text {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: #1a1a2e;
  gap: 2px;
}

.help-tour-text strong {
  font-weight: 600;
  font-size: 12px;
}

.help-tour-text span {
  color: #6c757d;
  font-size: 11px;
}

.help-tour-btn {
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #C2185B 0%, #C9194A 100%);
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  transition: opacity 0.15s;
  flex-shrink: 0;
}

.help-tour-btn:hover {
  opacity: 0.88;
}

/* ─────────────────────────────────────────
   REACT-JOYRIDE OVERRIDES
───────────────────────────────────────── */

/* Keep joyride tooltip above all panels */
.__floater {
  z-index: 10001 !important;
}

.__floater__body {
  font-family: 'Poppins', sans-serif !important;
  font-size: 13px !important;
}

/* Progress indicator pill */
.react-joyride__progress {
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Help/Help.css"],"names":[],"mappings":"AAAA;;2CAE2C;;AAE3C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE;IACE,WAAW;IACX,QAAQ;IACR,OAAO;EACT;AACF;;;AAGA;;2CAE2C;;AAE3C;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,6BAA6B;EAC7B,gBAAgB;EAChB,kCAAkC;EAClC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB,EAAE,4BAA4B;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa,EAAE,yBAAyB;EACxC,YAAY;EACZ,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,8BAA8B;EAC9B,gBAAgB;EAChB,kCAAkC;EAClC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;AACT;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe,EAAE,0CAA0C;EAC3D,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;;AAGA;;2CAE2C;;AAE3C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;2CAE2C;;AAE3C,0CAA0C;AAC1C;EACE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,kCAAkC;EAClC,eAAe;AACjB","sourcesContent":["/* ─────────────────────────────────────────\n   HELP PANEL (navbar dropdown)\n───────────────────────────────────────── */\n\n.help-panel-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1999;\n}\n\n.help-panel {\n  position: fixed;\n  top: 63px;\n  right: 0;\n  width: 420px;\n  max-height: calc(100vh - 63px);\n  background: #fff;\n  border-left: 1px solid #E3EBF8;\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.10);\n  z-index: 2000;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Poppins', sans-serif;\n}\n\n.help-panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 16px 16px 12px;\n  border-bottom: 1px solid #E3EBF8;\n  flex-shrink: 0;\n}\n\n.help-panel-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1a1a2e;\n}\n\n.help-panel-subtitle {\n  font-size: 12px;\n  color: #898989;\n  margin-top: 2px;\n}\n\n.help-panel-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #898989;\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: background 0.15s, color 0.15s;\n}\n\n.help-panel-close:hover {\n  background: #f3f4f6;\n  color: #1a1a2e;\n}\n\n.help-panel-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px 16px;\n}\n\n.help-panel-body::-webkit-scrollbar {\n  width: 4px;\n}\n\n.help-panel-body::-webkit-scrollbar-thumb {\n  background: #E3EBF8;\n  border-radius: 4px;\n}\n\n.help-section {\n  margin-bottom: 16px;\n}\n\n.help-section-label {\n  margin-bottom: 10px;\n}\n\n.help-section-badge {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #C9194A;\n  background: #fdf2f5;\n  border-radius: 4px;\n  padding: 2px 8px;\n}\n\n.help-section-badge--all {\n  color: #1D4ED8;\n  background: #eff6ff;\n}\n\n.help-video-card {\n  display: flex;\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid #f3f4f6;\n  align-items: flex-start;\n}\n\n.help-video-card:last-child {\n  border-bottom: none;\n}\n\n.help-video-thumbnail {\n  flex-shrink: 0;\n  width: 100px;\n  height: 56px;\n  border-radius: 6px;\n  overflow: hidden;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.help-thumbnail-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.help-thumbnail-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #fdf2f5, #ffe4ec);\n}\n\n.help-video-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.help-video-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a2e;\n  margin-bottom: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.help-video-desc {\n  font-size: 11px;\n  color: #898989;\n  line-height: 1.4;\n  margin-bottom: 8px;\n}\n\n.help-watch-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  background: linear-gradient(135deg, #C2185B 0%, #C9194A 100%);\n  border: none;\n  border-radius: 6px;\n  padding: 4px 12px;\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n\n.help-watch-btn:hover:not(:disabled) {\n  opacity: 0.88;\n}\n\n.help-watch-btn:disabled {\n  background: #e5e7eb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.help-panel-footer {\n  padding: 12px 16px;\n  border-top: 1px solid #E3EBF8;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.help-channel-link {\n  font-size: 12px;\n  color: #C9194A;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.help-channel-link:hover {\n  text-decoration: underline;\n  color: #C9194A;\n}\n\n/* Mobile: full-width panel */\n@media (max-width: 767.98px) {\n  .help-panel {\n    width: 100%;\n    right: 0;\n    left: 0;\n  }\n}\n\n\n/* ─────────────────────────────────────────\n   FLOATING VIDEO PLAYER\n───────────────────────────────────────── */\n\n.help-player {\n  width: 360px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n  border-top: 3px solid #C9194A;\n  overflow: hidden;\n  font-family: 'Poppins', sans-serif;\n  user-select: none;\n}\n\n.help-player--mobile {\n  width: calc(100vw - 16px);\n  left: 8px !important;\n  right: 8px !important;\n  bottom: 80px !important; /* above mobile bottom nav */\n}\n\n.help-player-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 10px;\n  background: #fafafa;\n  border-bottom: 1px solid #f3f4f6;\n  min-height: 36px;\n}\n\n.help-player-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a1a2e;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 220px;\n  flex: 1;\n}\n\n.help-player-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.help-ctrl-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6c757d;\n  width: 26px;\n  height: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: background 0.15s, color 0.15s;\n  padding: 0;\n}\n\n.help-ctrl-btn:hover {\n  background: #f3f4f6;\n  color: #1a1a2e;\n}\n\n.help-ctrl-close:hover {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.help-player-iframe {\n  width: 100%;\n  height: 202px; /* 16:9 for 360px width */\n  border: none;\n  display: block;\n}\n\n/* Minimized pill */\n.help-player-minimized {\n  width: 280px;\n  background: #fff;\n  border-radius: 24px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14);\n  border-left: 3px solid #C9194A;\n  overflow: hidden;\n  font-family: 'Poppins', sans-serif;\n  user-select: none;\n}\n\n.help-player-mini-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 10px 8px 14px;\n  gap: 8px;\n}\n\n.help-player-mini-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a1a2e;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n}\n\n/* Fullscreen modal */\n.help-fullscreen-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.72);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.help-fullscreen-modal {\n  width: min(80vw, 900px);\n  background: #fff;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.28);\n  border-top: 3px solid #C9194A;\n  font-family: 'Poppins', sans-serif;\n}\n\n.help-fullscreen-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  background: #fafafa;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.help-fullscreen-iframe {\n  width: 100%;\n  height: 56.25vw; /* 16:9 relative to 80vw container width */\n  max-height: 60vh;\n  border: none;\n  display: block;\n}\n\n@media (max-width: 767.98px) {\n  .help-player-minimized {\n    width: calc(100vw - 16px);\n    border-radius: 12px;\n  }\n  .help-fullscreen-modal {\n    width: 100vw;\n    border-radius: 0;\n  }\n  .help-fullscreen-iframe {\n    height: 56.25vw;\n    max-height: 50vh;\n  }\n}\n\n\n/* ─────────────────────────────────────────\n   GUIDED TOUR BANNER (inside HelpPanel)\n───────────────────────────────────────── */\n\n.help-tour-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  background: #fdf2f5;\n  border: 1px solid #f9c8d6;\n  border-radius: 8px;\n  padding: 10px 14px;\n  margin: 12px 16px 4px;\n  flex-shrink: 0;\n}\n\n.help-tour-text {\n  display: flex;\n  flex-direction: column;\n  font-size: 12px;\n  color: #1a1a2e;\n  gap: 2px;\n}\n\n.help-tour-text strong {\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.help-tour-text span {\n  color: #6c757d;\n  font-size: 11px;\n}\n\n.help-tour-btn {\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  background: linear-gradient(135deg, #C2185B 0%, #C9194A 100%);\n  border: none;\n  border-radius: 6px;\n  padding: 6px 12px;\n  cursor: pointer;\n  transition: opacity 0.15s;\n  flex-shrink: 0;\n}\n\n.help-tour-btn:hover {\n  opacity: 0.88;\n}\n\n/* ─────────────────────────────────────────\n   REACT-JOYRIDE OVERRIDES\n───────────────────────────────────────── */\n\n/* Keep joyride tooltip above all panels */\n.__floater {\n  z-index: 10001 !important;\n}\n\n.__floater__body {\n  font-family: 'Poppins', sans-serif !important;\n  font-size: 13px !important;\n}\n\n/* Progress indicator pill */\n.react-joyride__progress {\n  font-family: 'Poppins', sans-serif;\n  font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
